"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _HotelFactsItem = _interopRequireDefault(require("../HotelFactsItem"));
var _userflow = require("../../utils/userflow");
var _Button = _interopRequireDefault(require("../Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var pluralizeTexts = [_localization.i18n.t('hotel.facts.text', {
  count: 0
}), _localization.i18n.t('hotel.facts.text', {
  count: 1
}), _localization.i18n.t('hotel.facts.text', {
  count: 3
})];
var hiddenItemStyle = {
  display: 'none'
};
var HotelFactsMobile = function HotelFactsMobile(_ref) {
  var facts = _ref.facts,
    _ref$defaultVisible = _ref.defaultVisible,
    defaultVisible = _ref$defaultVisible === void 0 ? 4 : _ref$defaultVisible,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var factsCount = facts.length;
  var collpasedFactsCount = factsCount - defaultVisible;
  var _useState = (0, _react.useState)(collpasedFactsCount <= 0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledHotelFacts, {
    expanded: expanded
  }, facts.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(StyledFactsItem, (0, _extends2["default"])({}, item, {
      isMobile: true,
      key: item.title,
      style: expanded || index < defaultVisible ? undefined : hiddenItemStyle
    }));
  })), !expanded && /*#__PURE__*/_react["default"].createElement(StyledButton, {
    size: "none",
    onClick: function onClick() {
      return setExpanded(true);
    }
  }, "".concat(t('hotel.facts.still'), " ").concat(collpasedFactsCount, " ").concat((0, _userflow.pluralize)(collpasedFactsCount, pluralizeTexts))));
};
var StyledHotelFacts = _styledComponents["default"].div.withConfig({
  displayName: "HotelFactsMobile__StyledHotelFacts",
  componentId: "sc-yn9vi8-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;position:relative;", ""], function (_ref2) {
  var expanded = _ref2.expanded,
    theme = _ref2.theme;
  return !expanded && "\n    ::after {\n      content: \"\";\n      display: block;\n      background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), ".concat(theme.colors.white, " 98%);\n      height: 49px;\n      width: 100%;\n      position: absolute;\n      bottom: 20px;\n      pointer-events: none;\n    }\n  ");
});
var StyledFactsItem = (0, _styledComponents["default"])(_HotelFactsItem["default"]).withConfig({
  displayName: "HotelFactsMobile__StyledFactsItem",
  componentId: "sc-yn9vi8-1"
})(["flex:100%;max-width:100%;&:last-child{padding-bottom:0;}"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "HotelFactsMobile__StyledButton",
  componentId: "sc-yn9vi8-2"
})(["padding:12px 16px;font-size:14px;line-height:16px;font-style:normal;font-weight:400;color:var(--black);"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelFactsMobile);